import { render, staticRenderFns } from "./PermissionAdd.vue?vue&type=template&id=4bc8c0ee&scoped=true"
import script from "./PermissionAdd.vue?vue&type=script&lang=js"
export * from "./PermissionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc8c0ee",
  null
  
)

export default component.exports